import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { initAxiosInterceptors, ModalProvider, Modals } from "./utils";
import "./assets/styles/index.scss";
import "./assets/styles/global.scss";
import "swiper/swiper-bundle.css";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/keyboard";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/zoom";

import { store } from "./store";
import { BrowserRouter } from "react-router-dom";
import { ScrollToTop } from "components";

initAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ModalProvider>
      <Provider store={store}>
        <ScrollToTop />
        <App />
        <Modals />
      </Provider>
    </ModalProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
